//BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - Start

import { memo } from 'react';
import { BzChip, BzCard } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';

const TabEventsContent = ({ arrEventScrips, handleOnClickScrip, scripDetails, removeScrips, addScrips, onBuySellClick, handleOverview, nActiveCard, strSearchActiveTab, ...props }) => {
    return (
        <>
            <Container fluid className='px-3'>
                {arrEventScrips?.length > 0 && arrEventScrips?.map((each, i) => (
                    <BzCard key={i} className='p-0 py-3 bdr-card-btm' style={{ border: nActiveCard === i ? 'solid 1px' : null }} tabindex={nActiveCard === i ? 0 : -1} id={'globalsearchCard' + strSearchActiveTab + i}>
                        <Row className='g-0 global-search-focus'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0'>
                                        <Col>
                                            <div className='font-medium font-size3 color-text text-uppercase cursor-pointer text-nowrap'>{each?.title}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-1'>
                                        <Col className='chips-wrap'>
                                            <div className='chips-wrap'>
                                                <BzChip className='chips primary-chip align-self-center'>{each?.eventType}</BzChip>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <Row className='g-0 mt-2'>
                                            <Col className='justify-content-start align-self-center'>
                                                <div className='font-regular font-size3 color-subtext'>{Object.keys(each).includes('Memo') ? each.Memo : each.description}</div>
                                            </Col>
                                        </Row> */}
                                    <Row className='g-0 mt-2'>
                                        <Col className='justify-content-start align-self-center'>
                                            <div className='font-regular font-size1 color-subtext cursor-pointer'>{each?.eventDate}</div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-forward-arrow icon-dark' onClick={(e) => { e.stopPropagation(); handleOverview(each); }}></div>
                            </Col>
                        </Row>
                    </BzCard>
                ))}
            </Container>

        </>
    );
};

export default memo(TabEventsContent);

//BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - End

